module.exports = ".mainDSH {\r\n    width: 100%;\r\n    /* height: 100vh; */\r\n    background-color: rgb(226, 221, 221);\r\n}"